import { IcChevronLight } from '@assets/icons/16x16';
import { For, HStack, Icon, Text } from '@chakra-ui/react';
import { Fragment } from 'react/jsx-runtime';

type BreadcrumbProps = {
  items: {
    label?: string;
    action?: () => void;
  }[];
};

export function Breadcrumb({ items }: Readonly<BreadcrumbProps>) {
  return (
    <HStack gap={1.5}>
      <For each={items}>
        {({ label, action }, index) => (
          <Fragment key={index}>
            <Text
              color={index === items.length - 1 ? 'neutral.white' : 'neutral.300'}
              cursor={action ? 'pointer' : 'default'}
              _hover={
                action
                  ? {
                      color: 'skyBlue',
                    }
                  : {}
              }
              onClick={action}
            >
              {label ?? ''}
            </Text>
            {index !== items.length - 1 && <Icon as={IcChevronLight} color="neutral.300" boxSize="16px" />}
          </Fragment>
        )}
      </For>
    </HStack>
  );
}
